import { useMemo } from "react";
import Dropdown from "./Dropdown";

const DropDownRights = ({
  value,
  onChange,
  options = [],
  optionsValue = [],
  disabled = false,
}) => {
  const mappedOptions = useMemo(() => {
    const len = Math.min(options.length, optionsValue.length);
    return Array.from({ length: len }).map((_, idx) => ({
      label: options[idx],
      value: optionsValue[idx],
    }));
  }, [options, optionsValue]);
  return (
    <Dropdown
      variant="select"
      id="rights-select"
      value={value}
      onChange={onChange}
      options={mappedOptions}
      placeholderKey="dropdown.rights"
      disabled={disabled}
    />
  );
};

export default DropDownRights;
